import { useEffect, useState } from "react";
import axios from "axios";
import "../Styling-css/ContactPreviewTable.css";

const ContactPreviewTable = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/contacts`
      );
      const formatted = response.data.map((item) => ({
        ...item,
        date: formatDate(item.date),
        time: formatTime(item.date),
      }));
      setContacts(formatted);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching contacts:", error);
      setError("Failed to load contact messages.");
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BASE_URL}/contacts/${id}`);
      setContacts((prev) => prev.filter((item) => item.id !== id));
      // Optionally, display a success message
    } catch (error) {
      console.error("Error deleting contact:", error);
      // Optionally, display an error message
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date)
      ? "Invalid"
      : `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return isNaN(date)
      ? "Invalid"
      : `${date.getHours().toString().padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}`;
  };

  if (loading) {
    return <div>Loading contact messages...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="dashboard-container">
      <h2>Contact Messages</h2>
      <table>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Email</th>
            <th>Date</th>
            <th>Time</th>
            <th>Message</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((item, index) => (
            <tr key={item.id}>
              <td data-label="S.No">{index + 1}</td>
              <td data-label="Name">{item.name}</td>
              <td data-label="Email">{item.email}</td>
              <td data-label="Date">{item.date}</td>
              <td data-label="Time">{item.time}</td>
              <td data-label="Message">{item.message}</td>
              <td data-label="Delete">
                <button onClick={() => handleDelete(item.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ContactPreviewTable;
